import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=636d22c0&lang=pug&"
import script from "./HelpButton.vue?vue&type=script&lang=ts&"
export * from "./HelpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports